/**
 * Модуль различных задержек для скриптов
 */
import { timeIdle } from "./timeIdle";

$(document).ready(() => {
    timeIdle(10000, 'hh:promo-block:activation');
});